import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "row align-items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-8" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Cambio de contraseña")
  ])
], -1)
const _hoisted_2 = { class: "pl-lg-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_7 = { class: "pl-lg-4 d-flex w-100" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Guardar contraseña ")

import { ref } from "vue";
import { AlertModule } from "@/store/modules/Alert";
import { passwordSchema } from "@/store/schemas/user.schema";
// Components
import { Form } from "vee-validate";
import { coreApi } from "@/conection";

type PasswordPayload = {
	password: string;
	rpassword: string;
};


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

// State
const model = ref<Partial<PasswordPayload>>({});
const loading = ref(false);

//Methods
async function updatePassword(e: PasswordPayload) {
	loading.value = true;
	const response = await coreApi.post<{ success: boolean }>(
		"/api/agent/update",
		{ password: e.password }
	);
	loading.value = false;
	if (response.data.success) {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "Contraseña actualizada correctamente",
			type: "success",
		});
	} else {
		AlertModule.SOCKET_PUSH_NOTIFICATION({
			text: "Ocurrió un error, no se pudo actualizar la contraseña!",
			type: "error",
		});
	}
}

return (_ctx: any,_cache: any) => {
  const _component_base_input = _resolveComponent("base-input")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createBlock(_component_card, { class: "mt-0" }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    default: _withCtx(() => [
      _createVNode(_unref(Form), {
        "validation-schema": _unref(passwordSchema)(),
        onSubmit: _cache[0] || (_cache[0] = (e) => updatePassword(e))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_base_input, {
                  name: "password",
                  type: "password",
                  label: "Contraseña",
                  value: model.value.password
                }, null, 8, ["value"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_base_input, {
                  name: "rpassword",
                  type: "password",
                  label: "Confirme su contraseña",
                  value: model.value.rpassword
                }, null, 8, ["value"])
              ])
            ])
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_base_button, {
              class: "ml-auto",
              type: "primary",
              "native-type": "submit",
              loading: loading.value
            }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }, 8, ["loading"])
          ])
        ]),
        _: 1
      }, 8, ["validation-schema"])
    ]),
    _: 1
  }))
}
}

})